export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "error-logger.cb87a901a7164efa7cc3.worker.js");
}
